import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RuleService } from '../service/rule.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'cv-rule-feedback-component',
    templateUrl: 'rule-feedback.component.html',
    styleUrls: ['rule-feedback.component.scss']
})

export class RuleFeedbackComponent implements OnInit {
    @Input() orderId!: number;
    @Input() documentId!: string;
    @Input() ruleId!: string;
    @Output() feedbackSuccess = new EventEmitter<void>();
    public feedbackForm!: FormGroup;
    public feedbackLoading: boolean = false;
    public success: boolean = false;
    public errorMessage!: string | null;

    constructor(private ruleService: RuleService, private formBuilder: FormBuilder) { 
        this.feedbackForm = formBuilder.group({
            feedback: ['', Validators.required]
        })
    }

    ngOnInit() { }

    /**
     * Sends the entered rule feedback.
     */
    public onFeedBackSend(){
        if(this.feedbackForm.invalid) return;
        if(!this.documentId || !this.orderId || !this.ruleId) return;
        const feedback = this.feedbackForm.get('feedback')?.value;

        this.feedbackLoading = true;
        this.success = false;
        this.errorMessage = null;

        this.ruleService.sendRuleFeedBack(this.orderId, this.documentId, this.ruleId, feedback).subscribe({
            next: () => {
                this.feedbackLoading = false;
                this.success = true;
                this.feedbackForm.get('feedback')?.setValue('Thank you for your feedback!');
                this.feedbackForm.get('feedback')?.disable();
                setTimeout(() => {
                    this.feedbackSuccess.emit();
                }, 2000)
            },
            error: () => {
                this.feedbackLoading = false;
                this.errorMessage = 'There was an error sending feedback. Please try again.';
            }    
        })
    }   
}